module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAwBAMAAACcS1XvAAAAJ1BMVEVHcEwAoesAoeo3PEU4PEU4PEU7P0c3O0UAoOsAo+o3O0QAoOo3O0TwxRREAAAAC3RSTlMA5obmg7I9/bI9/s5iw20AAADZSURBVDjL3dQ7DsIwDAbgqOoFOnfpzti1Qw/AzMSKuAETF0BcAIkrsJQJlLEgFh+qVv/aTQyRWMFDFH9DHrYS57KicmPkdYsJZOGvSJf0wARS+g5pQz0mEO89UiLCBPJzrvcyrnUwrnUzrvGln4pD6FLnjNMqqLP05cx+D/oifTyy34I+SpTsnXsP65t6ZdYZJb/Qq432hWy5jLvonJA1j8/oXpCGxz46ACTl8zpSZ4juq32B5PvpnNrHSeRec99VjJswrlVVN+9F3bwX9f94L6l/IPVvfP5nBq3eERpUN91rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/home/strategy.png
// module id = +HeW
// module chunks = 20